import { render } from "./roster_detail.vue?vue&type=template&id=46d85cbd&scoped=true"
import script from "./roster_detail.vue?vue&type=script&lang=js"
export * from "./roster_detail.vue?vue&type=script&lang=js"

import "./roster_detail.vue?vue&type=style&index=0&id=46d85cbd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d85cbd"]])

export default __exports__